// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Product_order__\\+CEuj {
  color: var(--darkGray);
}

.Product_header__pUI-n {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.Product_title__VGKot {
  font-family: BebasNeue;
  font-weight: 700;
  color: var(--darkGray);
  font-size: 20px;
}

.Product_green__TrhRe {
  color: var(--orange);
}

.Product_clientInfo__x152r {
  background-color: var(--darkGray);
  color: white;
  padding: 10px 20px;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 25px;
}

.Product_clientDetail__UdGaJ {
  display: block;
}

.Product_labelClient__RA\\+e6 {
  display: inline-block;
  margin-right: 5px;
}

.Product_clientAddress__dDGkW {
  text-align: center;
}

.Product_clientPhone__C7dZ0 {
  text-align: right;
}

.Product_products__b9rXj {
  margin-bottom: 15px;
}

.Product_product__flB4q {
  border-bottom: 1px dashed #bfbfbf;
  padding-bottom: 20px;
  margin-bottom: 15px;
}

.Product_bullet__ZSSxp {
  display: inline-block !important;
  margin-right: 5px;
  padding-left: 2em;
}

.Product_extraItem__\\+-yOE {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  margin-bottom: 3px;
  width: 100%;
}

.Product_extraName__ygCvJ {
  flex: 1 1;
  margin-left: 5px;
  display: inline-block !important;
}

.Product_extraPrice__huv8Q {
  font-weight: 600;
  color: var(--orange);
  margin-left: auto;
  min-width: 50px;
  text-align: right;
  padding-right: 1.3em;
}

.Product_productName__\\+O2\\+- {
  font-family: BebasNeue;
  font-size: 18px;
}

.Product_details__fivJf {
  padding-left: 25px;
  margin-top: 5px;
}

.Product_details__fivJf span {
  display: block;
}

.Product_totalProduct__IQyl7 {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}

.Product_deliveryWrap__QtHBd {
  background-color: #f3f3f3;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}

.Product_price__zkn\\+2 {
  font-weight: 500;
}

.Product_label__0xvn6 {
  font-weight: 500;
  font-size: 13px;
}

.Product_tipWrap__4dQYY {
  padding: 15px;
  margin: 5px 0;
  border-bottom: 1px dashed #bfbfbf;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Product_totalWrap__qNIHz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
}

.Product_totalPrice__naKn6 {
  font-size: 15px;
  font-weight: 700;
}

.Product_ticket__SXVsu {
  font-weight: 800;
}

.Product_labelSection__cfFYD {
  font-family: BebasNeue;
  font-weight: 700;
  margin-bottom: 5px;
  display: block;
}

.Product_methodWrap__Dqn7y {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  border-top: 1px solid #c2c2c2;
  color: #444444;
}

.Product_methodWrap__Dqn7y:last-child {
  border-bottom: 1px solid #c2c2c2;
}

.Product_cashback__OVOcy {
  font-weight: 700;
}

.Product_method__mNxmv {
  display: flex;
  align-items: center;
}

.Product_methodIcon__E6wxO {
  margin-right: 15px;
}

.Product_paymentWrap__wu\\+qo {
  margin-bottom: 30px;
}

.Product_driverName__tnHja {
  font-weight: 700;
}

.Product_selectDriver__qIOFf {
  width: 100%;
  border-color: #d2d2d2;
  background-color: #fbfbfb;
}

.Product_selectDriver__qIOFf .Product_ant-select-selector__APQHB {
  border-radius: 6px !important;
}

.Product_driverAssign__Fhpuz,
.Product_accept__TUgZ4,
.Product_saveNotes__L2Qbe {
  font-weight: 700;
  font-size: 12px;
}

.Product_driverAssign__Fhpuz {
  margin: 0 auto;
  display: block;
  width: 100%;
}

.Product_saveNotesWrap__UFJXO {
  display: flex;
  justify-content: flex-end;
}

.Product_saveNotes__L2Qbe {
  width: 150px;
  margin-top: 10px;
}

.Product_historyWrap__5RtOe {
  margin-top: 30px;
}

.Product_prevOrder__y86Ub {
  border-top: 1px solid #c2c2c2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 25px;
}

.Product_prevOrder__y86Ub:last-child {
  border-bottom: 1px solid #c2c2c2;
}

.Product_seeMore__lP2EM {
  display: block;
  text-align: right;
  margin-top: 10px;
  text-decoration: underline;
  color: var(--darkGray);
}

.Product_seeMore__lP2EM:hover {
  color: var(--darkGray);
}

.Product_stepsWrap__gvb6\\+ {
  margin-top: 30px;
  border: 1px dashed #a8a8a8;
  background-color: #f3f3f3;
  border-radius: 4px;
  padding: 30px;
}

.Product_step__NHJwl {
  display: flex;
  border-top: 1px solid #d5d5d5;
  padding: 10px 15px;
  align-items: center;
  justify-content: space-between;
}

.Product_step__NHJwl:last-child {
  border-bottom: 1px solid #d5d5d5;
}

.Product_submitWrap__cfmNn {
  margin-top: 40px;
  display: flex;
  justify-content: flex-end;
}

.Product_accept__TUgZ4 {
  width: 200px;
}

.Product_reject__v2hgH {
  margin-right: 20px;
}

.Product_annotations__MasX\\+ {
  margin: 25px 0;
  color: var(--darkGray);
}

.Product_labelNotes__VuzF2 {
  font-weight: 700;
}

.Product_mainInfoWrap__4I1XY {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.Product_call__6c0ER {
  padding: 5px 15px;
  background-color: var(--orange);
  color: white;
  font-weight: 700;
  margin-left: 20px;
  border-radius: 4px;
  display: block;
}

.Product_step__NHJwl span:first-child {
  margin-right: 15px;
}

.Product_step__NHJwl span:last-child {
  text-align: right;
}

.Product_discount__tKQZL {
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  /* font-size: 15px; */
}

.Product_reasonWrap__v9h5Y {
  margin-top: 30px;
}

.Product_warning__mlCTK {
  margin-bottom: 20px;
}

@media only screen and (max-width: 992px) {
  .Product_mainInfoWrap__4I1XY {
    justify-content: space-between;
    margin-bottom: 20px;
    margin-top: -25px;
    display: flex;
  }

  .Product_paymentWrap__wu\\+qo {
    margin-top: 20px;
  }

  .Product_clientAddress__dDGkW {
    text-align: left;
  }

  .Product_clientPhone__C7dZ0 {
    text-align: left;
    color: #444444;
  }

  .Product_labelClient__RA\\+e6 {
    display: block;
    color: var(--darkGray);
    font-size: 12px;
  }

  .Product_clientDetail__UdGaJ {
    margin-bottom: 15px;
  }

  .Product_clientInfo__x152r {
    background-color: transparent;
    color: #444444;
    font-weight: 500;
    font-size: 13px;
    padding-left: 0;
  }

  .Product_submitWrap__cfmNn {
    width: 100%;
  }

  .Product_accept__TUgZ4 {
    width: 100%;
  }
}

pre {
  outline: 1px solid #ccc; padding: 5px; margin: 5px;
}

.Product_string__LZFKW { color: green;
}

.Product_number__ph-SL { color: darkorange;
}

.Product_boolean__DD6jq { color: blue;
}

.Product_null__a14Py { color: magenta;
}

.Product_key__-1hM5 { color: red;
}

.Product_btnGC__zM3j8 { border:0 !important; background:transparent !important;
}

.Product_peyaIconText__STnVK {
  display:inline-block;
  margin-right: 2em;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Product.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,6BAA6B;IAC7B,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AACA;EAAK,uBAAuB,EAAE,YAAY,EAAE,WAAW;AAAE;;AACzD,yBAAU,YAAY;AAAE;;AACxB,yBAAU,iBAAiB;AAAE;;AAC7B,0BAAW,WAAW;AAAE;;AACxB,uBAAQ,cAAc;AAAE;;AACxB,sBAAO,UAAU;AAAE;;AACnB,wBAAS,mBAAmB,EAAE,iCAAiC;AAAE;;AACjE;EACE,oBAAoB;EACpB,iBAAiB;AACnB","sourcesContent":[".order {\n  color: var(--darkGray);\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n}\n\n.title {\n  font-family: BebasNeue;\n  font-weight: 700;\n  color: var(--darkGray);\n  font-size: 20px;\n}\n\n.green {\n  color: var(--orange);\n}\n\n.clientInfo {\n  background-color: var(--darkGray);\n  color: white;\n  padding: 10px 20px;\n  font-weight: 500;\n  margin-top: 5px;\n  margin-bottom: 25px;\n}\n\n.clientDetail {\n  display: block;\n}\n\n.labelClient {\n  display: inline-block;\n  margin-right: 5px;\n}\n\n.clientAddress {\n  text-align: center;\n}\n\n.clientPhone {\n  text-align: right;\n}\n\n.products {\n  margin-bottom: 15px;\n}\n\n.product {\n  border-bottom: 1px dashed #bfbfbf;\n  padding-bottom: 20px;\n  margin-bottom: 15px;\n}\n\n.bullet {\n  display: inline-block !important;\n  margin-right: 5px;\n  padding-left: 2em;\n}\n\n.extraItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 13px;\n  margin-bottom: 3px;\n  width: 100%;\n}\n\n.extraName {\n  flex: 1;\n  margin-left: 5px;\n  display: inline-block !important;\n}\n\n.extraPrice {\n  font-weight: 600;\n  color: var(--orange);\n  margin-left: auto;\n  min-width: 50px;\n  text-align: right;\n  padding-right: 1.3em;\n}\n\n.productName {\n  font-family: BebasNeue;\n  font-size: 18px;\n}\n\n.details {\n  padding-left: 25px;\n  margin-top: 5px;\n}\n\n.details span {\n  display: block;\n}\n\n.totalProduct {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0 15px;\n}\n\n.deliveryWrap {\n  background-color: #f3f3f3;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n}\n\n.price {\n  font-weight: 500;\n}\n\n.label {\n  font-weight: 500;\n  font-size: 13px;\n}\n\n.tipWrap {\n  padding: 15px;\n  margin: 5px 0;\n  border-bottom: 1px dashed #bfbfbf;\n  margin-bottom: 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.totalWrap {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 15px;\n}\n\n.totalPrice {\n  font-size: 15px;\n  font-weight: 700;\n}\n\n.ticket {\n  font-weight: 800;\n}\n\n.labelSection {\n  font-family: BebasNeue;\n  font-weight: 700;\n  margin-bottom: 5px;\n  display: block;\n}\n\n.methodWrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 15px;\n  border-top: 1px solid #c2c2c2;\n  color: #444444;\n}\n\n.methodWrap:last-child {\n  border-bottom: 1px solid #c2c2c2;\n}\n\n.cashback {\n  font-weight: 700;\n}\n\n.method {\n  display: flex;\n  align-items: center;\n}\n\n.methodIcon {\n  margin-right: 15px;\n}\n\n.paymentWrap {\n  margin-bottom: 30px;\n}\n\n.driverName {\n  font-weight: 700;\n}\n\n.selectDriver {\n  width: 100%;\n  border-color: #d2d2d2;\n  background-color: #fbfbfb;\n}\n\n.selectDriver .ant-select-selector {\n  border-radius: 6px !important;\n}\n\n.driverAssign,\n.accept,\n.saveNotes {\n  font-weight: 700;\n  font-size: 12px;\n}\n\n.driverAssign {\n  margin: 0 auto;\n  display: block;\n  width: 100%;\n}\n\n.saveNotesWrap {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.saveNotes {\n  width: 150px;\n  margin-top: 10px;\n}\n\n.historyWrap {\n  margin-top: 30px;\n}\n\n.prevOrder {\n  border-top: 1px solid #c2c2c2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 25px;\n}\n\n.prevOrder:last-child {\n  border-bottom: 1px solid #c2c2c2;\n}\n\n.seeMore {\n  display: block;\n  text-align: right;\n  margin-top: 10px;\n  text-decoration: underline;\n  color: var(--darkGray);\n}\n\n.seeMore:hover {\n  color: var(--darkGray);\n}\n\n.stepsWrap {\n  margin-top: 30px;\n  border: 1px dashed #a8a8a8;\n  background-color: #f3f3f3;\n  border-radius: 4px;\n  padding: 30px;\n}\n\n.step {\n  display: flex;\n  border-top: 1px solid #d5d5d5;\n  padding: 10px 15px;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.step:last-child {\n  border-bottom: 1px solid #d5d5d5;\n}\n\n.submitWrap {\n  margin-top: 40px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.accept {\n  width: 200px;\n}\n\n.reject {\n  margin-right: 20px;\n}\n\n.annotations {\n  margin: 25px 0;\n  color: var(--darkGray);\n}\n\n.labelNotes {\n  font-weight: 700;\n}\n\n.mainInfoWrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.call {\n  padding: 5px 15px;\n  background-color: var(--orange);\n  color: white;\n  font-weight: 700;\n  margin-left: 20px;\n  border-radius: 4px;\n  display: block;\n}\n\n.step span:first-child {\n  margin-right: 15px;\n}\n\n.step span:last-child {\n  text-align: right;\n}\n.discount {\n  width: 22px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  /* font-size: 15px; */\n}\n\n.reasonWrap {\n  margin-top: 30px;\n}\n\n.warning {\n  margin-bottom: 20px;\n}\n\n@media only screen and (max-width: 992px) {\n  .mainInfoWrap {\n    justify-content: space-between;\n    margin-bottom: 20px;\n    margin-top: -25px;\n    display: flex;\n  }\n\n  .paymentWrap {\n    margin-top: 20px;\n  }\n\n  .clientAddress {\n    text-align: left;\n  }\n\n  .clientPhone {\n    text-align: left;\n    color: #444444;\n  }\n\n  .labelClient {\n    display: block;\n    color: var(--darkGray);\n    font-size: 12px;\n  }\n\n  .clientDetail {\n    margin-bottom: 15px;\n  }\n\n  .clientInfo {\n    background-color: transparent;\n    color: #444444;\n    font-weight: 500;\n    font-size: 13px;\n    padding-left: 0;\n  }\n\n  .submitWrap {\n    width: 100%;\n  }\n\n  .accept {\n    width: 100%;\n  }\n}\npre {outline: 1px solid #ccc; padding: 5px; margin: 5px; }\n.string { color: green; }\n.number { color: darkorange; }\n.boolean { color: blue; }\n.null { color: magenta; }\n.key { color: red; }\n.btnGC { border:0 !important; background:transparent !important; }\n.peyaIconText {\n  display:inline-block;\n  margin-right: 2em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"order": `Product_order__+CEuj`,
	"header": `Product_header__pUI-n`,
	"title": `Product_title__VGKot`,
	"green": `Product_green__TrhRe`,
	"clientInfo": `Product_clientInfo__x152r`,
	"clientDetail": `Product_clientDetail__UdGaJ`,
	"labelClient": `Product_labelClient__RA+e6`,
	"clientAddress": `Product_clientAddress__dDGkW`,
	"clientPhone": `Product_clientPhone__C7dZ0`,
	"products": `Product_products__b9rXj`,
	"product": `Product_product__flB4q`,
	"bullet": `Product_bullet__ZSSxp`,
	"extraItem": `Product_extraItem__+-yOE`,
	"extraName": `Product_extraName__ygCvJ`,
	"extraPrice": `Product_extraPrice__huv8Q`,
	"productName": `Product_productName__+O2+-`,
	"details": `Product_details__fivJf`,
	"totalProduct": `Product_totalProduct__IQyl7`,
	"deliveryWrap": `Product_deliveryWrap__QtHBd`,
	"price": `Product_price__zkn+2`,
	"label": `Product_label__0xvn6`,
	"tipWrap": `Product_tipWrap__4dQYY`,
	"totalWrap": `Product_totalWrap__qNIHz`,
	"totalPrice": `Product_totalPrice__naKn6`,
	"ticket": `Product_ticket__SXVsu`,
	"labelSection": `Product_labelSection__cfFYD`,
	"methodWrap": `Product_methodWrap__Dqn7y`,
	"cashback": `Product_cashback__OVOcy`,
	"method": `Product_method__mNxmv`,
	"methodIcon": `Product_methodIcon__E6wxO`,
	"paymentWrap": `Product_paymentWrap__wu+qo`,
	"driverName": `Product_driverName__tnHja`,
	"selectDriver": `Product_selectDriver__qIOFf`,
	"ant-select-selector": `Product_ant-select-selector__APQHB`,
	"driverAssign": `Product_driverAssign__Fhpuz`,
	"accept": `Product_accept__TUgZ4`,
	"saveNotes": `Product_saveNotes__L2Qbe`,
	"saveNotesWrap": `Product_saveNotesWrap__UFJXO`,
	"historyWrap": `Product_historyWrap__5RtOe`,
	"prevOrder": `Product_prevOrder__y86Ub`,
	"seeMore": `Product_seeMore__lP2EM`,
	"stepsWrap": `Product_stepsWrap__gvb6+`,
	"step": `Product_step__NHJwl`,
	"submitWrap": `Product_submitWrap__cfmNn`,
	"reject": `Product_reject__v2hgH`,
	"annotations": `Product_annotations__MasX+`,
	"labelNotes": `Product_labelNotes__VuzF2`,
	"mainInfoWrap": `Product_mainInfoWrap__4I1XY`,
	"call": `Product_call__6c0ER`,
	"discount": `Product_discount__tKQZL`,
	"reasonWrap": `Product_reasonWrap__v9h5Y`,
	"warning": `Product_warning__mlCTK`,
	"string": `Product_string__LZFKW`,
	"number": `Product_number__ph-SL`,
	"boolean": `Product_boolean__DD6jq`,
	"null": `Product_null__a14Py`,
	"key": `Product_key__-1hM5`,
	"btnGC": `Product_btnGC__zM3j8`,
	"peyaIconText": `Product_peyaIconText__STnVK`
};
export default ___CSS_LOADER_EXPORT___;
